export function getHexFromColorName(color: string) {
  const element = document.createElement("div");  
  element.style.color = color;

  document.body.appendChild(element)
  
  const rgb = window.getComputedStyle(element).color;

  document.body.removeChild(element);

  const [r, g, b] = rgb.split('(')[1].split(')')[0].split(',');

  return rgbToHex(+r, +g, +b);
}

export function rgbToHex(r: number, g: number, b: number) {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

function componentToHex(color: number) {
  var hex = color.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}